import { __assign, __awaiter, __generator } from "tslib";
import get from "lodash/get";
import keys from "lodash/keys";
import superagent from "superagent";
import jsonp from "superagent-jsonp";
import { getCookie } from "./cookie";
var requestPayload = {};
var _requestQueue = [];
function removeFromRequestQueue(req) {
    var findIndex = _requestQueue.findIndex(function (item) { return item.idx === req.idx; });
    _requestQueue.splice(findIndex, 1);
}
function resposneHandler(res) {
    removeFromRequestQueue(res.req);
}
function request(options) {
    return __awaiter(this, void 0, void 0, function () {
        var param, pendingRequest, throttleType, useCache, req, d, result, r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    param = __assign(__assign({}, options), { method: options.method || "GET", idx: options.idx || JSON.stringify(options), cache: options.cache === undefined ? false : options.cache, noCredentials: options.noCredentials === undefined ? false : options.noCredentials });
                    pendingRequest = _requestQueue.find(function (item) { return item.idx === param.idx; });
                    throttleType = options.throttleType || "drop";
                    useCache = param.cache && param.method.toLocaleLowerCase() === "get";
                    req = superagent(param.method, param.url);
                    if (param.jsonp) {
                        req = superagent(param.method || "GET", param.url).use(jsonp({
                            callbackParam: param.callbackParam || "callback",
                            callbackName: param.callbackName || "supercallback",
                            timeout: param.jsonpTimeout || 10000,
                        }));
                    }
                    if (!param.noCredentials) {
                        req.withCredentials();
                    }
                    req.timeout(param.timeout || 10000);
                    if (param.method.toLowerCase() === "post" && !param.form) {
                        d = get(param, "data", "");
                        if (!d) {
                            param.data = {};
                        }
                        if (!param.data.csrf) {
                            param.data.csrf = getCookie("bili_jct");
                        }
                        req.set("Content-Type", "application/x-www-form-urlencoded");
                    }
                    if (param.headers) {
                        keys(param.headers).forEach(function (k) {
                            req.set(k, param.headers[k]);
                        });
                    }
                    if (param.query) {
                        req.query(param.query);
                    }
                    if (!param.files) return [3, 1];
                    keys(param.data).forEach(function (key) {
                        req.field(key, param.data[key]);
                    });
                    keys(param.files).forEach(function (key) {
                        req.attach(key, param.files[key]);
                    });
                    return [3, 6];
                case 1:
                    if (!useCache) return [3, 5];
                    if (!(requestPayload[param.url] || pendingRequest)) return [3, 4];
                    if (!(pendingRequest && throttleType)) return [3, 4];
                    if (!(throttleType === "abort")) return [3, 2];
                    pendingRequest._req.abort();
                    removeFromRequestQueue(pendingRequest);
                    return [3, 4];
                case 2:
                    if (!(throttleType === "drop")) return [3, 4];
                    result = requestPayload[param.url] || pendingRequest._req;
                    return [4, result];
                case 3:
                    r = _a.sent();
                    return [2, r.body || r];
                case 4:
                    req.send(param.data);
                    if (throttleType) {
                        req.idx = param.idx;
                        _requestQueue.push({ idx: param.idx, _req: req });
                    }
                    _a.label = 5;
                case 5:
                    req.send(param.data);
                    _a.label = 6;
                case 6: return [2, req
                        .then(function (res) {
                        if (param.customResolve) {
                            return param.customResolve(res);
                        }
                        var body = res.body;
                        if (useCache) {
                            requestPayload[param.url] = body;
                        }
                        if (!body.code) {
                            return Promise.resolve(body);
                        }
                        if (+body.code !== 0) {
                            return Promise.reject(body);
                        }
                        resposneHandler(res);
                        return Promise.resolve(body);
                    })
                        .catch(function (error) {
                        return Promise.reject(error);
                    })];
            }
        });
    });
}
export default request;
//# sourceMappingURL=request.js.map